import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Background = ({
  image,
  foregroundImage,
  overlay,
  position,
  video,
  className,
  style,
}) => {
  const bgStyle = {
    backgroundImage: image ? `url(${image})` : "none",
    backgroundSize: "cover", // Ensures the background image covers the container fully
    backgroundRepeat: "no-repeat",
    backgroundPosition: typeof position === "string" ? position : "50% 50%",
    ...style,
  };

  if (typeof position === "object") {
    position.x && (bgStyle.backgroundPositionX = position.x);
    position.y && (bgStyle.backgroundPositionY = position.y);
  }

  return (
    <div
      className={classNames(
        "bg-holder",
        {
          overlay: overlay,
          [`overlay-${overlay}`]: typeof overlay === "string",
        },
        className
      )}
      style={bgStyle}
    >
      {foregroundImage && (
        <img
          src={foregroundImage}
          alt="Foreground Image"
          className="foreground-image"
          style={{
            position: "absolute",
            top: "40%",
            left: "25%",
            width: "50%",
          }}
        />
      )}
      {video && (
        <video className="bg-video" autoPlay loop muted playsInline>
          {video.map((src, index) => (
            <source
              key={index}
              src={src}
              type={`video/${src.split(".").pop()}`}
            />
          ))}
        </video>
      )}
    </div>
  );
};

Background.propTypes = {
  image: PropTypes.string, // Background image (optional to allow foreground-only use)
  foregroundImage: PropTypes.string, // Foreground image (optional)
  overlay: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  position: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      x: PropTypes.string,
      y: PropTypes.string,
    }),
  ]),
  video: PropTypes.array,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Background;
